import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';

import { AppSkeletonLoader } from '@/components/AppSkeletonLoader';
import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { RequireFeatureFlag } from '@/components/Auth/RequireFeatureFlag';
import { NotFound404 } from '@/components/NotFound404';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/$organizationName/org-docs')({
  component: GatedOrgDocsLayout,
  notFoundComponent: () => <NotFound404 />,
});

// Org Docs is default-off and org-admin only. Orgs without the flag are sent
// to the org home (which picks MCP Setup or My Sources by role), as if the
// feature didn't exist; org members in a flagged org get Forbidden.
function GatedOrgDocsLayout() {
  const { routeOrganizationName } = useUser();

  return (
    <RequireFeatureFlag
      flag={FEATURE_FLAGS.ORG_DOCS}
      loading={<AppSkeletonLoader />}
      redirect={<Navigate to="/$organizationName" replace params={{ organizationName: routeOrganizationName }} />}
    >
      <RequireEntitlements admins={['isSuperAdmin']}>
        <Outlet />
      </RequireEntitlements>
    </RequireFeatureFlag>
  );
}
